import ReCAPTCHA from 'react-google-recaptcha';

import * as S from './styled';
import { useQrCodeStartPage } from './useQrCodeStartPage';

import logo from '../../../assets/move-logo.png';
import { useTheme } from '../../../hooks/useTheme';
import { Shell } from '../../atoms/Shell/Shell';

const QrCodeStartPage = () => {
  const {
    chargeBoxId,
    connectorId,
    handleStart,
    handleStop,
    isVerified,
    recaptchaLoaded
  } = useQrCodeStartPage();

  const { theme } = useTheme();

  return (
    <S.QrCodeStartPageWrapper>
      {theme ? (
        <img src={logo} className="logo" width={200} height={50} />
      ) : <Shell height={50} width={200}  />}

      <S.QrCodeStartDesc>Estação: {chargeBoxId}</S.QrCodeStartDesc>

      <S.QrCodeStartDesc>Conector: {connectorId}</S.QrCodeStartDesc>

      <S.QrCodeStartTitle>Dê um START na Estação!</S.QrCodeStartTitle>

      <S.ReCaptchaWrapper>
        <ReCAPTCHA
          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
          render="explicit"
          onChange={recaptchaLoaded}
        />
      </S.ReCaptchaWrapper>

      <S.QrCodeStartButton disabled={!isVerified} onClick={handleStart}> START </S.QrCodeStartButton>

      <S.QrCodeStopButton disabled={!isVerified} onClick={handleStop}> STOP </S.QrCodeStopButton>
    </S.QrCodeStartPageWrapper>
  );
};

export default QrCodeStartPage;
